import React from 'react';
import PropTypes from 'prop-types';

import OccupancyDates from './OccupancyDates.jsx';
import s from './PoiSheet.module.scss';

const PoiHistorySheet = ({ polygonId, onOpenPolygon, rawFeatureId, onClose, pastEntities }) => (
    <React.Fragment>
        <div className={s.closeBox} onClick={onClose}>
            <span className="icon-close" />
        </div>
        <div className={s.poiSheet}>
            <div className={s.historyTitle}>
                <div className={s.title}>Unoccupied Space</div>
                <button type="button" className={s.addPoiButton} onClick={() => onOpenPolygon(polygonId, rawFeatureId)}>
                    <span className="icon-add-POI" /> ADD POI
                </button>
            </div>
            <div className={s.history}>
                {' '}
                <span className={s.label}>POLYGON HISTORY</span>{' '}
            </div>
            {pastEntities.map(dates => (
                <OccupancyDates closeDate={Date.now()} name={dates.name} openDate={Date.now()} unoccupied={dates.id.includes('#')} key={dates.id} />
            ))}
        </div>
    </React.Fragment>
);

PoiHistorySheet.propTypes = {
    onClose: PropTypes.func,
    onOpenPolygon: PropTypes.func,
    pastEntities: PropTypes.arrayOf(PropTypes.object),
    polygonId: PropTypes.string,
    rawFeatureId: PropTypes.string,
};

PoiHistorySheet.defaultProps = {
    onClose: () => {},
    onOpenPolygon: () => {},
    pastEntities: [{ name: 'Unoccupied', id: '#000' }],
    polygonId: '',
    rawFeatureId: '',
};

export default PoiHistorySheet;
